import {
  useFnsServiceCreateFormForAdminMutation,
  useFnsServiceUpdateFormForAdminMutation,
} from 'zma-react-sdk/fns-service'
import { useTenantStore } from '@/stores/tenantStore'
import { FormMutationInput } from '@/features/forms-and-surveys/types'

export function useCreateForm() {
  const { selectedTenantId } = useTenantStore()

  const [createForm, { loading, error }] =
    useFnsServiceCreateFormForAdminMutation({
      update: (cache, { data: _data }) => {
        // Invalidate and refetch the surveys list
        cache.evict({ fieldName: 'fnsServiceGetFormsForAdmin' })
        cache.gc()
      },
    })

  const handleCreate = async (input: FormMutationInput) => {
    const result = await createForm({
      variables: { input },
      context: {
        headers: {
          'x-tenant-id': selectedTenantId,
        },
      },
    })
    return result
  }

  return {
    createForm: handleCreate,
    loading,
    error,
  }
}

export function useUpdateForm() {
  const { selectedTenantId } = useTenantStore()

  const [updateForm, { loading, error }] =
    useFnsServiceUpdateFormForAdminMutation({
      refetchQueries: ['FnsServiceGetFormsForAdmin'],
    })

  const handleUpdate = async (id: string, input: FormMutationInput) => {
    const result = await updateForm({
      variables: { id, input },
      context: {
        headers: {
          'x-tenant-id': selectedTenantId,
        },
      },
    })
    return result
  }

  return {
    updateForm: handleUpdate,
    loading,
    error,
  }
}
